import React, { useEffect, useState, useRef } from "react";
import { VideoContainer } from "../styles/components/tiles";

const VideoMux = ({ muxvideo, autoplay, muted, loop }) => {
  const wrapperRef = useRef(null);
  const [MuxVideo, setMuxVideo] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined" || !muxvideo) return;
    const loadMuxVideo = async () => {
      try {
        const { default: MuxVideoComponent } = await import(
          "@mux/mux-video-react"
        );
        setMuxVideo(() => MuxVideoComponent);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    loadMuxVideo();
  }, [muxvideo]);
  return (
    <>
      {MuxVideo && muxvideo && (
        <VideoContainer>
          <MuxVideo
            style={{ height: "100%", width: "100%", maxWidth: "100%" }}
            playbackId={muxvideo.video?.muxPlaybackId}
            metadata={{
              video_id: muxvideo.video?.muxPlaybackId,
              video_title: muxvideo.title || "Highsnobiety Video",
            }}
            streamType="on-demand"
            controls={false}
            poster={muxvideo.video?.thumbnailUrl}
            autoPlay={autoplay}
            autopause="false"
            muted={muted}
            loop={loop}
            playsInline
            webkit-playsinline="true"
            x-webkit-airplay="allow"
            disablePictureInPicture
            disableRemotePlayback
          />
        </VideoContainer>
      )}
    </>
  );
};

export default VideoMux;
